import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../redux/actions/userActions";
import "./Login.css";
import { FaUser, FaLock } from "react-icons/fa";

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Access Redux state
  const { username: loggedInUser, error } = useSelector(
    (state: any) => state.user
  );

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(loginUser(username, password) as any);
  };

  // Redirect to dashboard if user is logged in
  useEffect(() => {
    if (loggedInUser) {
      navigate("/users");
    }
  }, [loggedInUser, navigate]);

  return (
    <div className="login-container">
      <div className="login-left">
        <h1 className="big-text">VV</h1>
        <p className="small-text">Your Journey Starts Here!</p>
      </div>
      <div className="login-right">
        <img
          src={`${process.env.PUBLIC_URL}/VV_logo.png`}
          alt="Logo"
          className="logo"
        />
        <form className="login-form" onSubmit={handleLogin}>
          <div className="input-group">
            <FaUser className="icon" />
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <FaLock className="icon" />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="login-button">
            LOGIN
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;

//----------------------------------------------------------------

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { loginUser } from "../../redux/actions/userActions";
// import "./Login.css";
// import { FaUser, FaLock } from "react-icons/fa";

// const Login: React.FC = () => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // Access Redux state
//   const { username: loggedInUser, error } = useSelector(
//     (state: any) => state.user
//   );

//   const handleLogin = (e: React.FormEvent) => {
//     e.preventDefault();
//     dispatch(loginUser(username, password) as any);
//   };

//   // Redirect to dashboard if user is logged in
//   useEffect(() => {
//     if (loggedInUser) {
//       navigate("/users");
//     }
//   }, [loggedInUser, navigate]);

//   return (
//     <div className="login-container">
//       <div className="login-left"></div>
//       <div className="login-right">
//         <img
//           src={`${process.env.PUBLIC_URL}/VV_logo.png`}
//           alt="Logo"
//           className="logo"
//         />
//         <form className="login-form" onSubmit={handleLogin}>
//           <div className="input-group">
//             <FaUser className="icon" />
//             <input
//               type="text"
//               placeholder="Username"
//               value={username}
//               onChange={(e) => setUsername(e.target.value)}
//               required
//             />
//           </div>
//           <div className="input-group">
//             <FaLock className="icon" />
//             <input
//               type="password"
//               placeholder="Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//           </div>
//           {error && <p className="error-message">{error}</p>}
//           <button type="submit" className="login-button">
//             LOGIN
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

//----------------------------------------------------------------

// import React from "react";
// import "./Login.css";
// import { FaEnvelope, FaLock, FaUser } from "react-icons/fa";

// const Login: React.FC = () => {
//   return (
//     <div className="login-container">
//       <div className="login-left">
//         {/* <div className="overlay">
//           <h1 className="title">Travelista Tours</h1>
//           <p className="subtitle">
//             Travel is the only purchase that enriches you in ways beyond
//             material wealth
//           </p>
//         </div> */}
//       </div>
//       <div className="login-right">
//         <img
//           src={`${process.env.PUBLIC_URL}/VV_logo.png`}
//           alt="Logo"
//           className="logo"
//         />
//         {/* <h2 className="welcome-title">Trips</h2> */}
//         {/* <p className="login-subtitle">Login with Email</p> */}
//         <form className="login-form">
//           <div className="input-group">
//             <FaUser className="icon" />
//             <input type="username" placeholder="username" required />
//           </div>
//           <div className="input-group">
//             <FaLock className="icon" />
//             <input type="password" placeholder="Password" required />
//           </div>
//           {/* <a href="#" className="forgot-password">
//             Forgot your password?
//           </a> */}
//           <button type="submit" className="login-button">
//             LOGIN
//           </button>
//         </form>
//         {/* <div className="or-divider">OR</div>
//         <div className="social-login">
//           <button className="social-button google">G</button>
//           <button className="social-button facebook">F</button>
//           <button className="social-button apple"></button>
//         </div>
//         <p className="register-text">
//           Don’t have an account?{" "}
//           <a href="#" className="register-link">
//             Register Now
//           </a>
//         </p> */}
//       </div>
//     </div>
//   );
// };

// export default Login;
